import React from 'react';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { useAuth } from '../../utils/context/AuthContext';
import { Link, useNavigate } from 'react-router-dom';

const MavBar = () => {
  const { user, logout, userData } = useAuth();
  const navigate = useNavigate();
  async function handleLogout() {
    try {
      const data = await logout();
      if (data) {
        navigate('/login');
      }
    } catch (error) {
      console.error('Error logging out', error);
    }
  }

  return (
    <Navbar expand="sm" className="bg-darkGray" sticky="top">
      <Container>
        <Navbar.Brand className="!text-todoister font-boldItalic" as={Link} to="/">
          TODOISTER
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbarScroll" />
        <Navbar.Collapse id="navbarScroll">
          <Nav className="me-auto my-2 my-lg-0" navbarScroll>
            {userData && (
              <Nav.Link as={Link} to="/profile" className="text-white">
                My Profile
              </Nav.Link>
            )}
          </Nav>
          <Nav className="ms-auto items-center ">
            {user ? (
              <>
                {userData && (
                  <span className="navbar-text me-3 text-white font-semiBold">
                    Hi, {userData?.firstName + ' ' + userData?.lastName || 'User'}!
                  </span>
                )}
                <Button variant="outline-light" onClick={handleLogout}>
                  Logout
                </Button>
              </>
            ) : (
              <Nav.Link as={Link} to="/login">
                <Button variant="outline-light">Login</Button>
              </Nav.Link>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default MavBar;
